module.exports = __webpack_public_path__ + "static/img/bg-home-hotel.903c3ee6.jpg";